import { ICorpusDocument } from '../../models/ICorpusDocument';
import { IBaseAction, IPromiseParam } from '../base';
import * as types from './actionTypes.corpus';

export interface IGetCorpusDocumentsParam extends IPromiseParam {
    corpusLine: string,
    corpusId: string,
    corpusTitle: string,
}

export const getCorpusDocuments = ({ corpusLine, corpusId, corpusTitle, resolve, reject }) => {
    return {
        type: types.GET_CORPUSE_REQ,
        corpusLine,
        corpusId,
        corpusTitle,
        resolve,
        reject
    };
};

export interface IGetCorpusDocumentParam extends IPromiseParam {
    corpusId: string,
    documentId: string,
}

export const getCorpusDocument = ({ corpusId, documentId, resolve, reject }: IGetCorpusDocumentParam) => {
    return {
        type: types.GET_CORPUSE_DOCUMENT_REQ,
        corpusId,
        documentId,
        resolve,
        reject
    };
};

export const clearCorpusInfo = ({ resolve, reject }) => {
    return {
        type: types.CLEAR_CORPUS_INFO_REQ,
        resolve,
        reject
    };
};

export interface ISearchByCorpusParam extends IPromiseParam {
    corpusId: string,
    query: string,
    question: string,
    maxTokens: number,
}

export const searchByCorpus = ({ corpusId, query, question, maxTokens, resolve, reject }: ISearchByCorpusParam) => {
    return {
        type: types.SEARCH_BY_CORPUSE_REQ,
        corpusId,
        query,
        question,
        maxTokens,
        resolve,
        reject
    };
};

export const clearCorpusSearch = ({ resolve, reject }: IPromiseParam) => {
    return {
        type: types.CLEAR_CORPUS_SEARCH_REQ,
        resolve,
        reject
    };
};

export interface ISelectCorpusDocumentParam extends IPromiseParam {
    document: ICorpusDocument,
    corpusId: string,
}

export const selectCorpusDocument = ({ document, corpusId, resolve, reject }: ISelectCorpusDocumentParam) => {
    return {
        type: types.SELECT_CORPUS_DOCUMENT_REQ,
        document,
        corpusId,
        resolve,
        reject
    };
};

export const selectCorpusDocumentInSearch = ({ document, corpusId, resolve, reject }: ISelectCorpusDocumentParam) => {
    return {
        type: types.SELECT_CORPUS_DOCUMENT_IN_SEARCH_REQ,
        document,
        corpusId,
        resolve,
        reject
    };
};



